import React from 'react';
import { Magazine } from '../../../components/countryside/Magazine/Magazine';
import { useApplicationContext } from '../../../utils/applicationContext';
import { data } from './constants';

export const CountrysideMagazineContainer = () => {
  const { config } = useApplicationContext();

  const showBlock = config.get<boolean>('countryside-mainpage-frontend.magazineBlock.Enabled');

  if (!showBlock) {
    return null;
  }

  return <Magazine {...data} />;
};
